import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Accordion, AccordionSummary, AccordionDetails, Menu, MenuItem, Box, Typography, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import FileUploader from "../../../TCPForms/reusableComponents/FileUploader";
import ButtonWrapper from "../../components/Button";
import { InfoBox, SummaryCard, CustomAccordionSummary } from "../../components/StyledComponent";
import { FaFilePdf } from "react-icons/fa";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import { Col, Row } from "react-bootstrap";
import RemarksEditor from "../../../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Loader } from "@egovernments/digit-ui-react-components";

const Step2 = ({ formData, handleTabChange, tenantId }) => {
  const dispatch = useDispatch();
  const { initFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { documents } = useSelector((state) => state.formMT);
  const userInfo = Digit.UserService.getUser();
  const { t } = useTranslation();
  const isDA = formData?.department === "DA";
  const isLowRiskCase = formData?.riskType === "LOW";
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);

  // Add state for remarks editor
  const [showRemarksEditor, setShowRemarksEditor] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState("");

  // State for Affidavit Conditions dropdown
  const [affidavitConditions, setAffidavitConditions] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  // Fetch Affidavit Conditions from MDMS
  const { data: mdmsData, isLoading: isAvpDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["AffidavitConditions"]);
  const modalMsg = {
    title: "Building Plan Upload – Declaration",
    body: `<p style="font-size:14px; text-align:left;">
    Before uploading the building plan drawing, please ensure the following mandatory Do’s are complied with:
  </p>

  <ul style="text-align:left; margin:10px 0; padding-left:20px; font-size:14px; list-style-type: disc;">
    <li style="margin-bottom:6px;">Always use the prescribed template for preparing the building plan map.</li>
    <li style="margin-bottom:6px;">Do not scale, stretch, rotate, crop, or modify the template in any manner.</li>
    <li style="margin-bottom:6px;">Always prepare, plot, print, and upload the drawing PDF in ISO A0 size.</li>
    <li style="margin-bottom:6px;">All drawings must be prepared using Meter (m) as the unit of measurement.</li>
    <li style="margin-bottom:6px;">Always select edge-to-edge template selection while creating the PDF.</li>
    <li style="margin-bottom:6px;">All plans, information, and data must remain strictly within the prescribed template area.</li>
    <li style="margin-bottom:6px;">Ensure there are no missing, extra, or duplicate elements outside the defined template boundary.</li>
    <li style="margin-bottom:6px;">Do not include watermarks, background images, or decorative graphics.</li>
    <li style="margin-bottom:6px;">Ensure compliance with all applicable Building Bye-laws, Development Control Regulations, and Authority norms.</li>
  </ul>

  <p style="font-size:14px; text-align:left;">
    By proceeding, you confirm that all the above conditions have been carefully reviewed and complied with.
  </p>

  <br/>`,
    type: "warning",
    redirectPath: null,

    btnText: "I Agree & Proceed",
  };
  // Load affidavit conditions from MDMS
  useEffect(() => {
    if (mdmsData?.BPA?.AffidavitConditions) {
      const conditionsArray = mdmsData.BPA.AffidavitConditions;
      if (conditionsArray.length > 0 && conditionsArray[0]?.conditions) {
        setAffidavitConditions(conditionsArray[0].conditions);
        console.log("Affidavit conditions loaded:", conditionsArray[0].conditions);
      }
    }
  }, [mdmsData]);

  const ownerSigntaureDocuments = documents?.filter((doc) => doc.documentType?.startsWith("signature_"));

  const defaultValues = {
    ...formData,
    // documents: documents
  };
  const isScheme = formData?.descriptionOfLand?.schemeType === "Scheme";
  const isSelfCert =
    formData?.planOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
    formData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const { handleSubmit, control, setValue, trigger } = useForm({ defaultValues });

  async function fetchLTPData() {
    const createdBy = userInfo?.info?.uuid;
    try {
      const response = await Digit.OBPSService.BPAREGSearch(tenantId, {}, { createdBy: createdBy });
      const ltpData = response?.Licenses?.filter((e) => e.status === "APPROVED") || [];
      const regCert = ltpData?.[0]?.tradeLicenseDetail?.applicationDocuments?.filter((e) => e.documentType === "Registration Certificate") || [];
      if (documents?.some((doc) => doc.documentType === "Registration Certificate")) return;
      // if(regCert?.length > 0){
      //   initFormMTDocs([...regCert, ...formData?.documents, ...documents ])
      // }
      //initFormMTDocs([...regCert, ...documents]);
    } catch (error) {
      console.error("Error fetching migrated data:", error);
    }
  }

  const migratedData = Digit.SessionStorage.get("MIGRATED_DATA");
  const migratedPlan = migratedData?.sanctionFiles?.find((item) => item.fileType === "Plan")?.fileStoreURL;
  const migratedSanctionLetter = migratedData?.sanctionFiles?.find((item) => item.fileType === "Certificate")?.fileStoreURL;

  useEffect(() => {
    fetchLTPData();
  }, []);

  useEffect(() => {
    if (formData?.documents?.length > 0) {
      initFormMTDocs(formData.documents);
    }
  }, [formData?.documents]);

  useEffect(() => {
    if (documents?.length >= 0) {
      setValue("documents", documents);
    }
  }, [documents, setValue]);

  // Function to handle Generate Affidavit
  const handleGenerateAffidavit = () => {
    setShowRemarksEditor(true);
  };

  // Function to handle saving remarks
  const handleSaveRemarks = () => {
    console.log("Saving remarks:", remarks);

    // Generate PDF using browser's print functionality
    generatePDFUsingPrint();
  };

  // Function to generate PDF using print functionality
  const generatePDFUsingPrint = () => {
    if (!remarks || remarks.trim() === "") {
      setError("Please add conditions to generate affidavit");
      return;
    }

    try {
      // Create HTML content for PDF
      const htmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Affidavit Document</title>
          <style>
            @page {
              margin: 20mm;
            }
            body {
              font-family: Arial, sans-serif;
              line-height: 1.6;
              color: #000;
            }
            .header {
              text-align: center;
              margin-bottom: 30px;
            }
            .title {
              font-size: 24px;
              font-weight: bold;
              color: #1F4A7C;
              margin-bottom: 10px;
            }
            .applicant-info {
              background-color: #f8f9fa;
              padding: 15px;
              border-radius: 5px;
              margin-bottom: 20px;
              border: 1px solid #dee2e6;
            }
            .conditions {
              margin-top: 30px;
            }
            .condition-item {
              margin-bottom: 15px;
            }
            .signature {
              margin-top: 50px;
              text-align: center;
            }
            .signature-line {
              width: 300px;
              margin: 40px auto 10px;
              border-top: 1px solid #000;
            }
            @media print {
              body {
                font-size: 12pt;
              }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="title">AFFIDAVIT</div>
            <div style="border-top: 2px solid #1F4A7C; margin: 20px 0;"></div>
          </div>
          
          <div class="applicant-info">
            <div><strong>Applicant Name:</strong> ${formData?.applicantName || "Not Provided"}</div>
            <div><strong>Application No:</strong> ${formData?.applicationNumber || "Not Provided"}</div>
            <div><strong>Date:</strong> ${new Date().toLocaleDateString()}</div>
          </div>
          
          <div class="conditions">
            <h3 style="color: #1F4A7C; border-bottom: 2px solid #1F4A7C; padding-bottom: 10px;">
              CONDITIONS AND DECLARATIONS
            </h3>
            ${remarks
              .split("\n\n")
              .map((condition) => `<div class="condition-item">${condition}</div>`)
              .join("")}
          </div>
          
          <div class="signature">
            <div style="margin-top: 30px; padding: 20px; border-top: 1px solid #ddd;">
              <div class="signature-line"></div>
              <div style="margin-top: 10px;">
                <strong>Applicant Signature</strong>
              </div>
            </div>
          </div>
          
          <div style="text-align: center; margin-top: 50px; color: #666; font-size: 11px;">
            <p>Generated on ${new Date().toLocaleString()}</p>
            <p>Building Permission System</p>
          </div>
        </body>
        </html>
      `;

      // Create a new window for printing
      const printWindow = window.open("", "_blank");
      printWindow.document.write(htmlContent);
      printWindow.document.close();

      // Trigger print after content loads
      printWindow.onload = function () {
        setTimeout(() => {
          printWindow.print();
          printWindow.close();

          // Close the editor
          setShowRemarksEditor(false);
          setRemarks("");
          setError("");
        }, 500);
      };
    } catch (error) {
      console.error("Error generating PDF:", error);
      setError("Failed to generate PDF. Please try again.");
    }
  };

  // Function to close remarks editor
  const handleCloseRemarksEditor = () => {
    setShowRemarksEditor(false);
    setRemarks("");
    setError("");
  };

  // Function to handle condition selection
  const handleConditionSelect = (condition) => {
    if (!condition) return;

    // Append the condition text to the remarks on a new line
    setRemarks((prevRemarks) => {
      if (prevRemarks) {
        // Check if the condition is already added (optional)
        const conditionAlreadyExists = prevRemarks.includes(condition.text);
        if (!conditionAlreadyExists) {
          // Add on a new line
          return prevRemarks + "\n\n" + `Condition ${condition.id}: ${condition.text}`;
        }
        return prevRemarks;
      } else {
        // First condition
        return `Condition ${condition.id}: ${condition.text}`;
      }
    });

    // Close the dropdown
    setAnchorEl(null);
  };

  // Simple Master Dropdown component with proper z-index
  const SimpleMasterDropdown = () => {
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
      <div style={{ position: "relative", zIndex: 9999 }}>
        <ButtonWrapper
          variant="outlined"
          color="primary"
          size="small"
          label="Master"
          type="button"
          onClick={handleClick}
          endIcon={<ArrowDropDownIcon />}
          sx={{
            backgroundColor: "#1F4A7C",
            color: "white",
            fontSize: "12px",
            padding: "5px 10px",
            "&:hover": {
              backgroundColor: "#157CB3",
            },
          }}
        />

        {/* Dropdown Menu with high z-index to appear above everything */}
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: 400,
              width: 500,
              maxWidth: "90vw",
              zIndex: 99999, // Very high z-index
              position: "fixed", // Use fixed positioning
            },
          }}
          style={{ zIndex: 99999 }} // Ensure menu has high z-index
          disablePortal={false} // Allow portal to escape container
          MenuListProps={{
            style: {
              padding: 0,
            },
          }}
        >
          <div
            style={{
              padding: "10px",
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #ddd",
              fontWeight: "bold",
              color: "#1F4A7C",
            }}
          >
            Affidavit Conditions
          </div>

          {isAvpDataLoading ? (
            <MenuItem disabled style={{ padding: "12px 16px" }}>
              Loading conditions...
            </MenuItem>
          ) : affidavitConditions.length === 0 ? (
            <MenuItem disabled style={{ padding: "12px 16px" }}>
              No conditions found
            </MenuItem>
          ) : (
            affidavitConditions.map((condition) => (
              <MenuItem
                key={condition.id}
                onClick={() => handleConditionSelect(condition)}
                style={{
                  whiteSpace: "normal",
                  padding: "12px 16px",
                  borderBottom: "1px solid #f0f0f0",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "#f0f7ff",
                  },
                }}
              >
                <div style={{ padding: "0" }}>
                  <div
                    style={{
                      fontWeight: "bold",
                      color: "#1F4A7C",
                      marginBottom: "4px",
                      fontSize: "13px",
                    }}
                  >
                    Condition {condition.id}
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#555",
                      lineHeight: "1.5",
                      fontFamily: "'Noto Sans Devanagari', 'Arial', sans-serif",
                    }}
                  >
                    {condition.text}
                  </div>
                </div>
              </MenuItem>
            ))
          )}
        </Menu>
      </div>
    );
  };

  // Custom RemarksEditor component
  const CustomRemarksEditor = ({ setRemarks, remarks, setError, error }) => {
    return (
      <div style={{ position: "relative", zIndex: 1 }}>
        {/* Toolbar with Master dropdown */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginBottom: "20px",
            padding: "10px",
            backgroundColor: "#f8f9fa",
            borderRadius: "4px",
            position: "relative",
            zIndex: 1,
          }}
        >
          <SimpleMasterDropdown />
        </div>

        {/* Current Remarks Preview */}
        <div
          style={{
            marginBottom: "20px",
            padding: "12px",
            backgroundColor: "#e8f4fd",
            borderRadius: "6px",
            border: "1px solid #b6d4fe",
          }}
        >
          <Typography
            variant="subtitle2"
            style={{
              fontWeight: "bold",
              color: "#1F4A7C",
              marginBottom: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span>Current Affidavit Text</span>
            <span style={{ fontSize: "12px", color: "#666", fontWeight: "normal" }}>{remarks.length} characters</span>
          </Typography>

          <div
            style={{
              minHeight: "60px",
              maxHeight: "120px",
              overflowY: "auto",
              padding: "10px",
              backgroundColor: "white",
              borderRadius: "4px",
              border: "1px solid #dee2e6",
              fontFamily: "'Noto Sans Devanagari', 'Arial', sans-serif",
              fontSize: "14px",
              lineHeight: "1.5",
              color: "#333",
              whiteSpace: "pre-line", // Changed to pre-line to preserve line breaks
            }}
          >
            {remarks || (
              <div
                style={{
                  color: "#999",
                  fontStyle: "italic",
                  textAlign: "center",
                  padding: "20px 0",
                }}
              >
                No text yet. Click "Master" dropdown to add affidavit conditions.
              </div>
            )}
          </div>

          {remarks && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "10px",
              }}
            >
              <ButtonWrapper
                variant="text"
                size="small"
                label="Clear All"
                onClick={() => setRemarks("")}
                sx={{
                  color: "#dc3545",
                  fontSize: "12px",
                  "&:hover": {
                    backgroundColor: "rgba(220, 53, 69, 0.1)",
                  },
                }}
              />
            </div>
          )}
        </div>

        {/* Use the existing RemarksEditor component */}
        <div style={{ position: "relative", zIndex: 1 }}>
          <Typography
            variant="subtitle2"
            style={{
              fontWeight: "bold",
              color: "#1F4A7C",
              marginBottom: "8px",
            }}
          >
            Edit Remarks:
          </Typography>

          <div
            style={{
              position: "relative",
              zIndex: 1,
              minHeight: "200px",
            }}
          >
            <RemarksEditor setRemarks={setRemarks} remarks={remarks} setError={setError} error={error} />
          </div>
        </div>
      </div>
    );
  };

  const onSubmit = (data) => {
    data = {
      ...data,
      nocDetails: formData?.nocDetails,
    };
    handleTabChange(2, data);
  };

  return (
    <section className="groupContainer">
      <form onSubmit={handleSubmit(onSubmit)}>
        {formData?.edcrNumber && (
          <SummaryCard className="formContainer">
            <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "100%" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", padding: "2rem" }}>
                  <Grid item xs={12} md={6}>
                    <Grid container spacing={2} style={{ padding: "1rem" }}>
                      <Grid item xs={6}>
                        <strong>{"Drawing Pdf"} </strong>:
                      </Grid>
                      <Grid item xs={6}>
                        <FaFilePdf
                          color="#a10505"
                          style={{ width: "20px", height: "30px", cursor: "pointer" }}
                          onClick={() => window.open(formData?.updatedDxfFile, "_blank")}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </table>
              </div>
            </div>
          </SummaryCard>
        )}

        <div className="formContainer">
          <div className="formHeaderContainer card-stript">
            <InfoBox>Sample Affidavit</InfoBox>
          </div>
        </div>

        {/* Affidavit Section - Fixed layout */}
        <SummaryCard className="formContainer affidavit-box">
          <div className="formInputContainer">
            <div style={{ width: "100%", padding: "1rem 2rem" }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={6}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <strong style={{ marginRight: "10px", minWidth: "100px" }}>Affidavit Pdf:</strong>
                    <FaFilePdf
                      color="#a10505"
                      style={{
                        width: "24px",
                        height: "30px",
                        cursor: "pointer",
                        marginRight: "15px",
                      }}
                      onClick={() => getDocumentByFileStoreId("9db90601-fd5e-416a-8fe9-cac1eec638d1", setIsPreviewLoading)}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div style={{ display: "flex", justifyContent: "flex-start" }}>
                    <ButtonWrapper
                      variant="outlined"
                      color="primary"
                      size="small"
                      label="GENERATE AFFIDAVIT"
                      type="button"
                      onClick={handleGenerateAffidavit}
                      sx={{
                        backgroundColor: "#28a745",
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "12px",
                        textTransform: "uppercase",
                        padding: "8px 16px",
                        borderRadius: "4px",
                        border: "none",
                        minWidth: "180px",
                        "&:hover": {
                          backgroundColor: "#218838",
                          border: "none",
                        },
                      }}
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </SummaryCard>

        {/* Fetched Documents Section */}
        {formData?.natureOfConstruction !== "New" && (
          <React.Fragment>
            <div className="formContainer">
              <div className="formHeaderContainer card-stript">
                <InfoBox>Fetched Documents</InfoBox>
              </div>
            </div>

            <SummaryCard className="formContainer affidavit-box">
              <div className="formInputContainer">
                <div style={{ width: "100%", padding: "1rem 2rem" }}>
                  {/* Plan Row */}
                  <Grid container spacing={2} alignItems="center" style={{ marginBottom: "1rem" }}>
                    <Grid item xs={12} md={6}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <strong style={{ marginRight: "10px", minWidth: "100px" }}>Plan:</strong>
                        <FaFilePdf
                          color="#a10505"
                          style={{
                            width: "24px",
                            height: "30px",
                            cursor: "pointer",
                          }}
                          onClick={() => window.open(migratedPlan, "_blank")}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      {/* Empty space for alignment */}
                    </Grid>
                  </Grid>

                  {/* Sanction Letter Row */}
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={6}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <strong style={{ marginRight: "10px", minWidth: "100px" }}>Sanction Letter:</strong>
                        <FaFilePdf
                          color="#a10505"
                          style={{
                            width: "24px",
                            height: "30px",
                            cursor: "pointer",
                          }}
                          onClick={() => window.open(migratedSanctionLetter, "_blank")}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      {/* Empty space for alignment */}
                    </Grid>
                  </Grid>
                </div>
              </div>
            </SummaryCard>
          </React.Fragment>
        )}

        {/* Remarks Editor Modal */}
        {showRemarksEditor && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 9999,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: "8px",
                padding: "30px",
                width: "80%",
                maxWidth: "800px",
                maxHeight: "80vh",
                overflow: "auto",
                boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
                position: "relative",
                zIndex: 10000,
              }}
            >
              <div style={{ marginBottom: "20px" }}>
                <h2 style={{ color: "#1F4A7C", borderBottom: "2px solid #1F4A7C", paddingBottom: "10px" }}>Affidavit Conditions Editor</h2>
                <p style={{ color: "#666", fontSize: "14px", marginTop: "5px" }}>
                  Use the "Master" dropdown to insert affidavit conditions into the text
                </p>
              </div>

              {/* Error message */}
              {error && (
                <div
                  style={{
                    padding: "10px",
                    backgroundColor: "#f8d7da",
                    color: "#721c24",
                    borderRadius: "4px",
                    marginBottom: "20px",
                    border: "1px solid #f5c6cb",
                  }}
                >
                  {error}
                </div>
              )}

              {/* Use Custom Remarks Editor with dropdown */}
              <CustomRemarksEditor setRemarks={setRemarks} remarks={remarks} setError={setError} error={error} />

              {/* Action Buttons */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  marginTop: "20px",
                  borderTop: "1px solid #eee",
                  paddingTop: "20px",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <ButtonWrapper
                  variant="outlined"
                  color="secondary"
                  size="medium"
                  label="Cancel"
                  type="button"
                  onClick={handleCloseRemarksEditor}
                  sx={{
                    backgroundColor: "#6c757d",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#5a6268",
                    },
                  }}
                />
                <ButtonWrapper
                  variant="contained"
                  color="primary"
                  size="medium"
                  label="Generate Affidavit"
                  type="button"
                  onClick={handleSaveRemarks}
                  sx={{
                    backgroundColor: "#1F4A7C",
                    "&:hover": {
                      backgroundColor: "#157CB3",
                    },
                  }}
                />
              </div>
            </div>
          </div>
        )}

        <Accordion defaultExpanded>
          <CustomAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Mandatory Documents")}</h2>
            </div>
          </CustomAccordionSummary>
          <AccordionDetails>
            <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
              <div className="columnWrapper">
                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader
                      label={t("Architect/Engineer Registration Certificate")}
                      control={control}
                      name="Registration Certificate"
                      validationMsg="Upload File"
                      required
                      isMandatory
                      trigger={trigger}
                    />
                  </Col>

                  {!isLowRiskCase && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Calculation sheet of Estimate with Affidavit")}
                        control={control}
                        name="calculationSheet"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  {!isScheme && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Khatauni")}
                        control={control}
                        name="khatauni"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  {!isSelfCert && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Owner Affidavit")}
                        control={control}
                        name="ownerAffidavit"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  {isSelfCert && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Drawing Pdf")}
                        control={control}
                        name="drawingPdf"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                        showModal={true}
                        modalMsg={modalMsg}
                      />
                    </Col>
                  )}

                  {isScheme && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        control={control}
                        label={t("Allotment Letter/Possession Letter")}
                        name="allotmentLetterPossessionLetter"
                        validationMsg="Upload File"
                        required
                        maxFiles={4}
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  <Col md={6}>
                    <FileUploader
                      label={t("Registry Deed/up to date payment certificate from property section/Hire Purchase Tentant/Agreement")}
                      control={control}
                      name="registrySaleDeedHPTA"
                      isMandatory
                      validationMsg="Upload File"
                      required
                      trigger={trigger}
                    />
                  </Col>

                  {isSelfCert && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("LTP Affidavit")}
                        control={control}
                        name="ltpAffidavit"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  {!isScheme && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Developer/Consortium/Sales Agreement")}
                        control={control}
                        name="developerConsortiumSalesAgreement"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  {!isDA && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Upto date payment letter")}
                        control={control}
                        name="uptodatePaymentLetter"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}
                  <Col md={12}>
                    <div className="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
                  </Col>
                </Row>
              </div>

              <div className="columnWrapper">
                <Row className="inner-mini-wrapper">
                  <Col md={4}>
                    <FileUploader
                      isMandatory
                      label={t("Site Photo")}
                      control={control}
                      name="sitePhoto"
                      validationMsg="Upload File"
                      required
                      maxFiles={4}
                      tab={2}
                      trigger={trigger}
                    />
                  </Col>

                  <Col md={4}>
                    {ownerSigntaureDocuments && ownerSigntaureDocuments?.length > 0 ? (
                      <div
                        style={{
                          maxHeight: "250px",
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}
                      >
                        {ownerSigntaureDocuments?.map((doc, index) => (
                          <div
                            key={doc.id || index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "10px",
                              width: "100%",
                              marginBottom: "8px",
                            }}
                          >
                            <span>Owner Signature {index + 1}</span>

                            <IconButton size="small" color="info" onClick={() => getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)}>
                              <VisibilityIcon />
                            </IconButton>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <FileUploader
                        isMandatory
                        label={t("Owner Signature")}
                        control={control}
                        name="signature"
                        validationMsg="Upload File"
                        required
                        tab={2}
                        trigger={trigger}
                      />
                    )}
                  </Col>

                  <Col md={4}>
                    <FileUploader
                      isMandatory
                      label={t("LTP Signature")}
                      control={control}
                      name="ltpSignature"
                      validationMsg="Upload File"
                      required
                      tab={2}
                      trigger={trigger}
                    />
                  </Col>
                  <Col md={12}>
                    <div className="text-red important-note">Note: (jpg, jpeg, png file only and Max file Size 10 MB)*</div>
                  </Col>
                </Row>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>

        {/* Conditional Documents Accordion */}
        <Accordion>
          <CustomAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Conditional Documents")}</h2>
            </div>
          </CustomAccordionSummary>
          <AccordionDetails>
            <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
              <div className="columnWrapper">
                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader label={t("Structural Audit Report")} control={control} name="structuralAuditReport" validationMsg="Upload File" />
                  </Col>

                  <Col md={6}>
                    <FileUploader label={t("Additional Document if any")} control={control} name="additionalDoc" validationMsg="Upload File" />
                  </Col>
                  <Col md={6}>
                    <FileUploader
                      label={t("Structural Drawing and Design ")}
                      control={control}
                      name="structuraldrawing"
                      validationMsg="Upload File"
                    />
                  </Col>
                  <Col md={6}>
                    <FileUploader
                      label={t("Structural Stability Certificate")}
                      control={control}
                      name="structuralcertificate"
                      validationMsg="Upload File"
                    />
                  </Col>
                  <Col md={6}>
                    <FileUploader
                      label={t("Structural Design calculation Report")}
                      control={control}
                      name="calculationReport"
                      validationMsg="Upload File"
                    />
                  </Col>

                  <Col md={6}>
                    <FileUploader
                      control={control}
                      label={t("Vetted Structure and drawing along with certificate")}
                      name="vettedStructure"
                      validationMsg="Upload File"
                    />
                  </Col>
                  <Col md={6}>
                    <FileUploader
                      label={t("Annexture 7, 8, 9, 10 duly signed by Owner, Architect and Structure Engineer.")}
                      control={control}
                      name="annexture789"
                      validationMsg="Upload File"
                    />
                  </Col>

                  <Col md={6}>
                    {isDA && (
                      <FileUploader
                        label={t("Upto date payment letter")}
                        control={control}
                        name="uptodatePaymentLetter"
                        validationMsg="Upload File"
                      />
                    )}
                  </Col>
                  <Col md={12}>
                    <div className="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
                  </Col>
                </Row>
              </div>
              <div className="columnWrapper">
                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader
                      label={t("Approved Layout sanctioned Letter")}
                      control={control}
                      name="sanctionLetter"
                      validationMsg="Upload File"
                    />
                  </Col>

                  <Col md={12}>
                    <div className="text-red important-note">Note: (jpg, jpeg, png file only and Max file Size 10 MB)*</div>
                  </Col>
                </Row>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>

        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="error"
              size="medium"
              label="Prev"
              sx={{ backgroundColor: "#CCC" }}
              onClick={() => handleTabChange(0)}
            />
            <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
          </div>
        </div>
      </form>
    </section>
  );
};

export default Step2;
